import React, { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import classNames from 'classnames';
import { Button, InputGroup, InputGroupAddon, Input, Form, FormGroup } from 'reactstrap';
import { Modal } from "react-bootstrap";
import { hasError, convertToRupiah, getCloudImageUrl, formatCurrencyWithMinus } from '../../../utils';
import { RESOURCE_URL } from '../../../config';
const userBalanceIcon = `${RESOURCE_URL}icons/kickcredit.png`;
import { FormFeedback } from '../../Forms';
import { connect } from "react-redux";

import CircleCloseButton from "../../../images/delete-input.png";
import BackButton from "../../../images/circle-back.png";
import InfoYellow from "../../../images/danger-sign-yellow.png";
import InfoRed from "../../../images/danger-sign-red.png";
import RoundCloseButton from "../../../images/round-close-button.png";

const ChooseAmountValues = [50000, 100000, 250000, 1000000, 3000000, 10000000]

const isDisabled = (value) => {
  return value == 0 || parseInt(value) < 50000
}

const ModalTopUp = props => {
  const [focused, setFocused] = React.useState(false)
  const onFocus = () => setFocused(true)
  const onBlur = () => setFocused(false)
  const isSellerCreditMinus = parseInt(props.dataAuth?.userdata?.balance_with_fee ?? "0") < 0
  const minusBalance = isSellerCreditMinus ? parseInt(props.dataAuth?.userdata?.balance_with_fee) : 0

  const selectedInput = props.choosedAmount ? props.choosedAmount : parseInt(props.amount);

  const inputMinusBalance = selectedInput - Math.abs(minusBalance);

  const toggleHandler = () => {
    if (props.isOpen) {
      props.deleteAllAmount()
    }
    props.onToggle()
  }

  return (
    <Modal
      className="modal-topup-v3"
      show={props.isOpen}
      onHide={toggleHandler}
      centered
    >
      <Form
        id="topup-container"
        onSubmit={e => {
          e.preventDefault();
          if (!isDisabled(props.amount)) props.onNextPage(2);
        }}
      >
        <KickImage onClick={toggleHandler} className='close-btn' src={RoundCloseButton} alt='close-btn' />
        <div className="topup-title">
          <div onClick={() => toggleHandler()} className='btn-wrapper'>
            <KickImage src={BackButton} alt='back-btn' />
          </div>
          <span>Top Up Kick Credit</span>
        </div>
        <div className='scrollable-wrapper'>
          <div className="topup-content">

            <div className='info-wrapper fee-info'>
              <div className='info-icon'>
                <KickImage src={InfoYellow} alt='back-btn' />
              </div>
              <p>Administration fee of IDR 5.000 will be charged <span>on any top up amount.</span></p>
            </div>

            <div className='choose-amount-wrapper'>
              <p>Choose an amount</p>
              <div className='amount-wrapper'>
                {ChooseAmountValues.map((amount, index) => {
                  return <button
                    className={`${props.choosedAmount === amount ? 'selected' : ''}`}
                    onClick={() => props.setChoosedAmount(amount)}
                    key={index + Math.floor(Math.random() * 10000)}
                  >
                    {formatCurrencyWithMinus(parseInt(amount), props.ratio, props.currency)}
                  </button>
                })}
              </div>
            </div>

            <div className='input-amount-wrapper'>
              {!props.choosedAmount ? <div className="text-desc">
                <p>Or input the amount yourself</p>
              </div> : null}
              <FormGroup className="topup-input">
                <InputGroup className={
                  classNames(
                    { "is-invalid": hasError(props.error && props.error.errors, 'amount') },
                    { "focused": focused }
                  )
                }>
                  <label>IDR</label>
                  <Input
                    value={parseInt(props.amount) ? convertToRupiah(parseInt(props.amount)) : ''}
                    onChange={props.onTextChange}
                    name="_amount"
                    onFocus={onFocus}
                    onBlur={onBlur}
                    autoComplete="off"
                  />
                  {
                    props.amount ?
                      <KickImage onClick={() => props.deleteAmountInput()} className='remove-value-btn' src={CircleCloseButton} alt='remove-value-btn' /> : null
                  }
                </InputGroup>
                <FormFeedback errors={props.error && props.error.errors} field="total_amount" />
                {
                  selectedInput ?
                    <p style={{color: "#159953"}}>You will receive IDR {`${convertToRupiah((parseInt(selectedInput) < Math.abs(minusBalance)) ? 0 : Math.abs(inputMinusBalance))}`}</p>
                    :
                    <p style={{color: "#E02020"}}>Minimal top up IDR {`${convertToRupiah(parseInt(50000))}`}</p>
                }
              </FormGroup>
            </div>

            {
              props.isSellerCreditMinus ?
                <div className='info-wrapper negative-seller-info'>
                  <div className='info-icon'>
                    <KickImage src={InfoRed} alt='back-btn' />
                  </div>
                  <p>Due to a negative seller credit balance your top up amount received will be deducted by the required amount to offset the negative balance. (Negative balance - IDR {convertToRupiah(Math.abs(parseInt(props.sellerCredit)))})</p>
                </div> : null
            }

            <div className='bottom-topup-info'>
              <div className='container-info'>
                <p>Why should I top up the kick credit?</p>
                <p>Payments done by Kick Wallet will be free of any administration charges and will be processed instantly</p>
              </div>
            </div>
          </div>
        </div>
        <div className="topup-button">
          <Button
            className={classNames("topup-content", { "btn": props.amount > 0, "btn2": isDisabled(props.amount) })}
            disabled={isDisabled(props.amount) || props.isTyping}
            onClick={() => props.onNextPage(2)}
          >
            Next
          </Button>
        </div>
      </Form>
    </Modal >
  )
}


const mapStateToProps = (state) => ({
  dataAuth: state.dataAuth,
  currency: state.dataAuth.userCurrency.currency,
  ratio: state.dataAuth.userCurrency.ratio,
})

export default connect(mapStateToProps, null)(ModalTopUp);